import React from 'react';
import { Card, Col, Row } from 'reactstrap';
import { EmptyLayout } from 'components/Layout';
import { Button, Form, FormGroup, Input, Label, FormFeedback } from 'reactstrap';
import { loginFormValidations } from 'form-validations';
import { connect } from 'react-redux';
import { LoginAction, UIAction } from 'redux/actions';
import AlertMessage from 'components/AlertMessage';
import { useNavigate } from 'react-router-dom';
import PageSpinner from 'components/PageSpinner';
import { Link } from 'react-router-dom';

const LoginPage = (props) => {

  let [values, setValues] = React.useState({});
  let [errors, setErrors] = React.useState({});
  let [isSubmitted, setIsSubmitted] = React.useState(false);
  let [isValid, setIsValid] = React.useState(true);
  let [showLoader, setShowLoader] = React.useState(false);
  const navigate = useNavigate();
  const isFirstRender = React.useRef(true);

  React.useEffect(() => {
    if (isFirstRender.current) {
      props.showMessages(null);
      isFirstRender.current = false;
    }
  })

  const handleSubmit = () => {
    setIsSubmitted(true);
    if (isValid) {
      props.login(values);
      setShowLoader(true);
    }
  }

  const handleChange = (event) => {
    setValues({
      ...values, [event.target.name]: event.target.value
    })
  };

  React.useEffect(() => {
    const validationErrors = loginFormValidations(values);
    isValid = Object.keys(validationErrors).length === 0;
    setIsValid(isValid);
    setErrors(validationErrors);
  }, [values]);

  

  React.useEffect(() => {
    
    if (props.loginSuccess) {
      navigate('/verify-otp');
    }
  }, [props.loginSuccess]);

  React.useEffect(() => {
    setShowLoader(false);
  }, [props.uiMessage]);

  return (
    <EmptyLayout>

      <Row className={'login-page-row'} >
        {(showLoader) ? <PageSpinner />
          : <Col md={6} lg={4}>
            <div style={{ minHeight: 55 }}><AlertMessage /></div>
            <Card body className="login-card">
              <Form>
                <div className="text-center pb-4">
                  Admin Login
                </div>
                <FormGroup>
                  <Label for={'username'}>{'Username'}</Label>
                  <Input
                    type="text"
                    name="username"
                    id="username"
                    onChange={handleChange}
                    autoComplete={'off'}
                    value={(values && values.username) ? values.username : ''}
                  />
                  {(isSubmitted && errors.username && !values.username) && <FormFeedback >{errors.username} </FormFeedback>}
                </FormGroup>
                <FormGroup>
                  <Label for={'password'}>{'Password'}</Label>
                  <Input
                    type="password"
                    name="password"
                    id="password"
                    onChange={handleChange}
                    autoComplete={'off'}
                    value={(values && values.password) ? values.password : ''}
                  />
                  {(isSubmitted && errors.password && !values.password) && <FormFeedback >{errors.password} </FormFeedback>}
                </FormGroup>

                <Button
                  size="lg"
                  color="primary"
                  className="border-0"
                  block
                  onClick={handleSubmit}>
                  Login
                </Button>
                <div style={{ textAlign: 'center', marginTop: 10 }} ><Link to={'/forgot-password'}>Forgot password</Link></div>
              </Form>
            </Card>

          </Col>
        }
      </Row>
    </EmptyLayout>
  )
}

const mapStateToProps = (state) => ({
  loginSuccess: (state.loginReducer && state.loginReducer.loginSuccess && state.loginReducer.loginSuccess.key) ? state.loginReducer.loginSuccess.key : null,
  loginData: (state.loginReducer && state.loginReducer.loginData && state.loginReducer.loginData.user) ? state.loginReducer.loginData.user : null,
  uiMessage: (state.uiReducer && state.uiReducer.uiMessage) ? state.uiReducer.uiMessage : null
});
const mapDispatchToProps = (dispatch) => ({
  login: (payload) => dispatch(LoginAction.tryLogin(payload)),
  showMessages: (payload) => dispatch(UIAction.showMessages(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);

//export default LoginPage;

